import axios from "axios";
import BaseApi from "./baseApi";
// import fakeTimeline from "@/api/json/fake/timeline-response.json";

export default class MachinesApi extends BaseApi {
  getMachineStatusFromTo(machineId, search) {
    // return fakeTimeline.result;
    return axios
      .get(`${this.url}/api/machines/${machineId}/status`, { params: search })
      .then(response => response.data.result);
  }

  getMachineStatusAggregated(machineId, from, to) {
    return axios
      .get(`${this.url}/api/machines/${machineId}/status/aggregated`, {
        params: { from, to }
      })
      .then(response => response.data.result.statuses);
  }

  getMachineStatusHistoricalAggregated(machineId, selectedHistory, from, to) {
    const aggregatedBy = selectedHistory === "year" ? "months" : "days";
    const params = { aggregatedBy, from, to };

    return axios
      .get(`${this.url}/api/machines/${machineId}/status/historical-aggregated`, { params })
      .then(response => response.data.result.statuses)
      .catch(() => ({}));
  }

  getMachineStatusLastByMachineId(machineId) {
    return axios
      .get(`${this.url}/api/machines/${machineId}/status/last`)
      .then(response => response.data.result);
  }

  getMachineStatusLastByMachineIds(machineIds) {
    return axios
      .get(`${this.url}/api/machines/last-status?machineIds=${machineIds.join()}`)
      .then(response => response.data.result);
  }
}
